export const referralEn = {
  bonuses: {
    '2025-03': {
      subtitle: {
        click: 'March only — click to share!',
        tap: 'March only — tap to share!',
      },
      title: 'Earn $1,500 per referral 💰',
    },
    '2025-04': {
      subtitle: {
        click: 'April only — click to share!',
        tap: 'April only — tap to share!',
      },
      title: 'Earn $1,500 per referral 💰',
    },
    default: {
      subtitle: {
        click: 'Click to share!',
        tap: 'Tap to share!',
      },
      title: 'Earn $1,000 per referral 💰',
    },
  },
}
